export const cartKeyWords = {
  ungrouped: 'ungrouped',
  localStorageKey: 'cart',
};
